export const ASSIGN_LICENSE_REQUEST = 'users/apps/ASSIGN_LICENSE_REQUEST';
export const ASSIGN_LICENSE_SUCCESS = 'users/apps/ASSIGN_LICENSE_SUCCESS';
export const ASSIGN_LICENSE_FAILURE = 'users/apps/ASSIGN_LICENSE_FAILURE';

export const UNASSIGN_LICENSE_REQUEST = 'users/apps/UNASSIGN_LICENSE_REQUEST';
export const UNASSIGN_LICENSE_SUCCESS = 'users/apps/UNASSIGN_LICENSE_SUCCESS';
export const UNASSIGN_LICENSE_FAILURE = 'users/apps/UNASSIGN_LICENSE_FAILURE';

export const LICENSE_REQUEST = 'users/apps/LICENSE_REQUEST';
export const LICENSE_SUCCESS = 'users/apps/LICENSE_SUCCESS';
export const LICENSE_FAILURE = 'users/apps/LICENSE_FAILURE';
